import { useMemo } from 'react';
import { useWineAppContext } from '../context/WineAppContext';
import * as actions from './actions';

export const useWineAppState = () => {
    const { state, dispatch } = useWineAppContext();

    // Create action dispatchers
    const dispatchers = useMemo(() => ({
        // Navigation
        setCurrentStep: (step) => dispatch(actions.setCurrentStep(step)),
        nextStep: () => dispatch(actions.nextStep()),
        previousStep: () => dispatch(actions.previousStep()),
        resetApp: () => dispatch(actions.resetApp()),

        // Dining Location
        setDiningLocation: (location) => dispatch(actions.setDiningLocation(location)),

        // Restaurant
        setRestaurant: (restaurant) => dispatch(actions.setRestaurant(restaurant)),
        setAllRestaurants: (restaurants) => dispatch(actions.setAllRestaurants(restaurants)),
        setFilteredRestaurants: (restaurants) => dispatch(actions.setFilteredRestaurants(restaurants)),
        setShowSuggestions: (show) => dispatch(actions.setShowSuggestions(show)),
        setSelectedSuggestionIndex: (index) => dispatch(actions.setSelectedSuggestionIndex(index)),
        setRestaurantNotFound: (notFound) => dispatch(actions.setRestaurantNotFound(notFound)),

        // Wine Preferences
        setWinePreferences: (preferences) => dispatch(actions.setWinePreferences(preferences)),
        setSelectedWinePreferences: (preferences) => dispatch(actions.setSelectedWinePreferences(preferences)),
        toggleWinePreference: (preference) => dispatch(actions.toggleWinePreference(preference)),

        // Food Preferences
        setFoodChoice: (choice) => dispatch(actions.setFoodChoice(choice)),
        setSelectedFoodPreferences: (preferences) => dispatch(actions.setSelectedFoodPreferences(preferences)),
        toggleFoodPreference: (preference) => dispatch(actions.toggleFoodPreference(preference)),

        // Price Range
        setPriceRange: (range) => dispatch(actions.setPriceRange(range)),
        setSelectedPriceRangeLabel: (label) => dispatch(actions.setSelectedPriceRangeLabel(label)),

        // Other Info
        setOtherInfo: (info) => dispatch(actions.setOtherInfo(info)),

        // Messages
        setConfirmationMessage: (message) => dispatch(actions.setConfirmationMessage(message)),

        // Recommendations
        setRecommendations: (recommendations) => dispatch(actions.setRecommendations(recommendations)),
        setIsLoadingRecommendations: (loading) => dispatch(actions.setIsLoadingRecommendations(loading)),
        setErrorFetchingRecommendations: (error) => dispatch(actions.setErrorFetchingRecommendations(error)),

        // Restaurant Summary
        setRestaurantSummary: (summary) => dispatch(actions.setRestaurantSummary(summary)),
        setIsLoadingSummaries: (loading) => dispatch(actions.setIsLoadingSummaries(loading)),
        setErrorFetchingSummaries: (error) => dispatch(actions.setErrorFetchingSummaries(error)),

        // Wine Details
        setSelectedWine: (wine) => dispatch(actions.setSelectedWine(wine)),
        setSelectedWineInfo: (info) => dispatch(actions.setSelectedWineInfo(info)),
        setIsLoadingWineInfo: (loading) => dispatch(actions.setIsLoadingWineInfo(loading)),

        // Restaurant Menu
        setRestaurantMenu: (menu) => dispatch(actions.setRestaurantMenu(menu)),
        setIsLoadingRestaurantMenu: (loading) => dispatch(actions.setIsLoadingRestaurantMenu(loading)),
        setErrorFetchingRestaurantMenu: (error) => dispatch(actions.setErrorFetchingRestaurantMenu(error))
    }), [dispatch]);

    return {
        // State
        ...state,
        
        // Action dispatchers
        ...dispatchers
    };
};
